import { render, staticRenderFns } from "./ModalDetailBRS.vue?vue&type=template&id=5fd89cf7"
import script from "./ModalDetailBRS.vue?vue&type=script&lang=js"
export * from "./ModalDetailBRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports